module.exports = __webpack_public_path__ + "img/Modern-Heritage_fr.5f258a60.jpg";